import { retentionsStatusLabels, retentionsTypeLabels } from "helpers/retentionsDictionary";

export const WHOLESALER_RETENTIONS_LABELS = {
  title: "Retenciones de Comisionistas",
  headers: {
    customerName: "Cliente Mayorista",
    type: "Tipo",
    amount: "Monto",
    unit: "Unidad",
    month: "Mes",
    year: "Año",
    status: "Estado",
    actions: "Acciones",
    folio: "Folio liquidación",
    date: "Fecha",
  },
  tooltips: {
    viewDetail: "Ver detalle",
    authorize: "Autorizar",
    deliver: "Marcar entregado",
    reject: "Rechazar",
    delete: "Eliminar",
  },
  modals: {
    create: "Nuevo Pago de Retención",
  },
  filters: {
    noOptions: "Sin opciones",
  },
  messages: {
    selectStation: "Selecciona una planta",
  },
  statusMap: retentionsStatusLabels,
  typeMap: retentionsTypeLabels,
};
